import { render, staticRenderFns } from "./ResourceRoute.vue?vue&type=template&id=65e0de4c&scoped=true"
import script from "./ResourceRoute.vue?vue&type=script&lang=js"
export * from "./ResourceRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0de4c",
  null
  
)

export default component.exports